import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './registerSW'
import { initSentry } from './lib/sentry'

// Service Worker registration is handled by registerSW (Vite PWA plugin)
initSentry();

createRoot(document.getElementById("root")!).render(
  <App />
);
